function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.32422 13.5195C3.35156 14.2031 3.95312 14.75 4.63672 14.75H11.3359C12.0195 14.75 12.6211 14.2031 12.6484 13.5195L13.25 4.25H2.75L3.32422 13.5195ZM13.6875 1.625H10.625L10.2969 0.996094C10.2148 0.859375 10.0781 0.75 9.91406 0.75H6.05859C5.89453 0.75 5.75781 0.859375 5.67578 0.996094L5.375 1.625H2.3125C2.06641 1.625 1.875 1.84375 1.875 2.0625V2.9375C1.875 3.18359 2.06641 3.375 2.3125 3.375H13.6875C13.9062 3.375 14.125 3.18359 14.125 2.9375V2.0625C14.125 1.84375 13.9062 1.625 13.6875 1.625Z",
  fill: "currentColor"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.454c4da2.svg";
export { ForwardRef as ReactComponent };